import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";

import upIcon from "src/assets/i_up.svg";
import downIcon from "src/assets/i_down.svg";
import hotIcon from "src/assets/hot.svg";

import eventBus from "src/utils/eventBus";
import { getChannelDetail } from "src/api/ChannelApi";

interface RankingTableProps {
    contents: {
        channel_title?: string;
        subscribe_cnt?: number;
        score?: number;
        category_name?: string;
        category_id?: number;
        rank?: number;
        rank_cap?: number;
        photo?: string;
        channel_id?: string;
        prev_rank?: number;
    }[];
}

const RankingTable: React.FC<RankingTableProps> = ({ contents }) => {
    const rankTab = useSelector((state: RootState) => state.tab.rankTab);
    const rankCategoryId = useSelector((state: RootState) => state.category.rankCategoryId);
    const recommend = useSelector((state: RootState) => state.main.recommend);

    const handleOpenModal = ( channel_id ) => {
        const fetchData = async () => {
            const response = await getChannelDetail(channel_id);
            if (response) {
                eventBus.emit("channelPreviewModal:show", { channel: response.data });
            } 
            else {
                alert("채널 상세정보 불러오기 실패!");
            }
        };
        fetchData();
    };

    return (
        <div className="table">
            <table className="table table-white table-hover">
                <colgroup>
                    <col style={{width: "15%"}} />
                    <col style={{width: "70%"}} />
                    <col style={{width: "15%"}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="text-center text-black3">
                            <p>순위</p>
                        </th>
                        <th className="text-center text-black3">
                            <p>채널명</p>
                        </th>
                        { 
                        rankTab === '스코어' ?
                        (rankCategoryId === 0?
                        <th className="text-center text-black3">
                            <p>랭킹상승</p>
                        </th>:
                        <th className="text-center text-black3">
                            <p>스코어</p>
                        </th>)
                        :(rankCategoryId === 0?
                        <th className="text-center text-black3">
                            <p>랭킹상승</p>
                        </th>:
                        <th className="text-center text-black3">
                            <p>구독자수</p>
                        </th>)
                        }
                    </tr>
                </thead>
                <tbody>
                    {recommend.map((value, index) =>
                        value.recommend_gb === 'RANK' ? (<tr 
                        className="highlight"
                        onClick={() => handleOpenModal(value.channel_id)} 
                        style={{ cursor: "pointer" }}>
                            <td className="text-center gap-2">
                                <small className="text-red fw-semibold p-test">추천</small>
                            </td>
                            <td>
                            <a className="d-flex align-items-center gap-2">
                                <div className="user_img" style={{ backgroundImage: `url(${value.photo})`}}></div>
                                <div className="txt">
                                    <p className="fw-semibold ellipsis-box p-test">
                                        {value.channel_title}
                                    </p>
                                </div>
                            </a>
                            </td>
                            <td className="text-center text-red">
                                    <i><img className="hot-img" src={hotIcon} alt="" /></i>
                            </td>
                        </tr>
                    ): null )}
                    
                    {contents.map((content, index) => {
                        const change = content.rank && content.prev_rank ? content.prev_rank - content.rank : 0;
                        const rank = content.rank ? content.rank : index + 1
                        return(
                        <tr 
                            key={index}
                            onClick={() => handleOpenModal(content.channel_id)} 
                            style={{ cursor: "pointer" }}>
                            <td className="text-center">
                                <small className={`number${rank <= 3 ? " bg-red text-white" : ""}`}>{rank}</small>
                                {
                                    change!==0 &&
                                    <div className={`rank ${change < 0 ? "down" : "up"}`}>
                                        <i><img src={ change < 0 ? downIcon : upIcon } alt="" /></i> {Math.abs(change)}
                                    </div>
                                }
                            </td>
                            <td>
                            <a className="d-flex align-items-center gap-2">
                                <div className="user_img" style={{ backgroundImage: `url(${content.photo})`}}></div>
                                <div className="txt">
                                    <p className="fw-semibold ellipsis-box p-test">
                                        {content.channel_title}
                                    </p>
                                </div>
                            </a>
                            </td>
                            {
                                rankTab === '스코어' ? 
                                (rankCategoryId === 0?
                                    <td className="text-center text-black5">{content.rank_cap}</td> :
                                    <td className="text-center text-black5">{content.score?.toFixed(1)}</td> 
                                )
                                :(rankCategoryId === 0?<td className="text-center text-black5">{content.rank_cap}</td> :
                                <td className="text-center text-black5">{content.subscribe_cnt?.toLocaleString()}</td>
                                )}
                        </tr>
                    )})}
                </tbody>
            </table>
        </div>
    );
};

export default RankingTable;